import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdatePrivateProjectBankItemName = async (
  projectId,
  privateItemId,
  newName
) => {
  const apiPath = `project-bank/private/project/${projectId}/item/${privateItemId}/rename`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { newName },
  });

  const response = await axios(signedRequest);

  return response.data;
};
